module.exports = __webpack_public_path__ + "img/icon_aside_bg_hover.95b5c41b.svg";